import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { MaxIntensityTsabtsTableComponent } from './max-intensity-tsabts.table';
import { MaxIntensityRankingRsabt } from '@data';
import { BaseCardComponent } from '../../atoms/cards/base-card/base-card.component';
import { ActionCardIconComponent } from '../../atoms/cards/action-card/action-card-icon.component';
import { CardTopHeader } from '../../atoms/card-top-header/card-top-header.component';
import { IconComponent } from '../../atoms/icon/icon.component';
import { LoaderWrapperComponent } from '../../atoms/loader-wrapper/loader-wrapper.component';

@Component({
  selector: 'ui-max-intensity-tsabts-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MaxIntensityTsabtsTableComponent,
    BaseCardComponent,
    ActionCardIconComponent,
    CardTopHeader,
    IconComponent,
    LoaderWrapperComponent,
  ],
  template: `
    <ui-base-card [width]="'full'" [class]="'!items-start'">
      <ng-container content>
        <div class="flex flex-col gap-y-7">
          <div class="flex justify-start items-center gap-x-4">
            <ui-action-card-icon
              icon
              class="{{ iconClass() }}"
              [icon]="icon()"
            />
            <div class="flex flex-row justify-between w-full">
              <ui-card-top-header [title]="title()" [subtitle]="subtitle()" />
              <div class="flex gap-x-2 text-xs text-neutral-7 leading-none">
                <ui-icon icon="calendar" />
                <span>{{ periodLabel() }}</span>
              </div>
            </div>
          </div>
          <ui-loader [loading]="loading()">
            <ui-max-intensity-tsabts-table
              [data]="data()"
              [showCenterCode]="showCenterCode()"
              [loading]="loading()"
              (onCenter)="emitCenter($event)"
              (onRsabtId)="emitRsabtId($event)"
            />
          </ui-loader>
        </div>
      </ng-container>
    </ui-base-card>
  `,
})
export class MaxIntensityTsabtsCardComponent {
  data = input.required<MaxIntensityRankingRsabt[]>();
  title = input.required<string>();
  subtitle = input.required<string>();
  periodLabel = input.required<string>();
  showCenterCode = input.required<boolean>();
  loading = input<boolean>(false);

  onCenter = output<{
    distributorId: string;
    centerId: string;
    rsabtId: string;
    tsabtId: string;
    vtnId: string;
  }>();
  onRsabtId = output<string>();

  icon = signal<string>('icons:transformer');
  iconClass = signal<string>(
    'text-purple bg-purple-light shadow-custom-purple',
  );

  emitRsabtId(id: string) {
    this.onRsabtId.emit(id);
  }
  emitCenter(event: {
    distributorId: string;
    centerId: string;
    rsabtId: string;
    tsabtId: string;
    vtnId: string;
  }) {
    this.onCenter.emit(event);
  }
}
